import { Loader } from '../Widgets';
import React, { useState, useEffect } from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { Session, User } from 'service';
import { useSelector } from 'react-redux';
import { RootState } from 'store/store';
import LoadingImage from '../../assets/loading.png'
import UnloadingImage from '../../assets/unloading.png'
import AttendanceImage from '../../assets/attendance.png'
import EmployeeAllocationImage from '../../assets/employee-allocation.png'
import ProductionEntryImage from '../../assets/production_entry.png'
import StockStatusImage from '../../assets/stock-status.png'
import { app_version, clearCache } from 'service/Utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBoxesStacked, faClipboardList, faIndustry } from '@fortawesome/free-solid-svg-icons';

export const Dashboard = () => {
    const userData = useSelector((state: RootState) => state.appdata);
    const [session, setSession] = useState<Session>();
    const [isLoading, setIsLoading] = useState<boolean>(true);

    useEffect(() => {
        if (userData.profile) {
            setSession(userData.profile.profile);
        }
    }, [userData]);

    useEffect(() => {
        if (session != null) {
            setIsLoading(false);
        }
    }, [session]);

    return (
        <>
            <div className="page-dashboard">
                {isLoading &&
                    <Loader />
                }
                {!isLoading &&
                    <>
                        {session && session.user && session.user.name &&
                            <div className='page-header bg-dark' style={{ paddingBottom: "20px", marginBottom: "20px" }}>
                                Welcome,
                                <h2>{session?.user.name}</h2>
                            </div>
                        }
                        <div className='row'>
                            {session?.activities && session?.activities.indexOf("app.employee.loading") > -1 &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/loading" className="d-block h-100 text-decoration-none">
                                        <div className="card h-100 d-flex flex-column">
                                            <img className="card-img-top" src={LoadingImage} alt="Card image cap"></img>
                                            <div className="card-body d-flex align-items-center justify-content-center text-center" style={{ minHeight: 80 }}>
                                                <h5 className="card-title mb-0" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>Loading</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            }
                            {session?.activities && session?.activities.indexOf("app.employee.unloading") > -1 &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/unloading" className="d-block h-100 text-decoration-none">
                                        <div className="card h-100 d-flex flex-column">
                                            <img className="card-img-top" src={UnloadingImage} alt="Card image cap"></img>
                                            <div className="card-body d-flex align-items-center justify-content-center text-center" style={{ minHeight: 80 }}>
                                                <h5 className="card-title mb-0" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>Unloading</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            }
                            {session?.activities && session?.activities.indexOf("app.employee.attendance") > -1 &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/attendance" className="d-block h-100 text-decoration-none">
                                        <div className="card h-100 d-flex flex-column">
                                            <img className="card-img-top" src={AttendanceImage} alt="Attendance"></img>
                                            <div className="card-body d-flex align-items-center justify-content-center text-center" style={{ minHeight: 80 }}>
                                                <h5 className="card-title mb-0" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>Attendance</h5>
                                            </div>
                                        </div>
                                    </NavLink>
                                </div>
                            }
                            {session?.activities && session?.activities.indexOf("app.employee.stock_status") > -1 &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/stock-status" className="d-block h-100 text-decoration-none">
                                        <div className="card h-100 d-flex flex-column">
                                                <img className="card-img-top" src={StockStatusImage} alt="Card image cap"></img>
                                                <div className="card-body d-flex align-items-center justify-content-center text-center" style={{ minHeight: 80 }}>
                                                    <h5 className="card-title mb-0" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>Stock Status</h5>
                                                </div>
                                            </div>
                                    </NavLink>
                                </div>
                            }
                            {session?.activities && session?.activities.indexOf("app.employee.work_allocation") > -1 &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/employee-allocation" className="d-block h-100 text-decoration-none">
                                        <div className="card h-100 d-flex flex-column">
                                                <img className="card-img-top" src={EmployeeAllocationImage} alt="Card image cap"></img>
                                                <div className="card-body d-flex align-items-center justify-content-center text-center" style={{ minHeight: 80 }}>
                                                    <h5 className="card-title mb-0" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>Employee Allocation</h5>
                                                </div>
                                            </div>
                                    </NavLink>
                                </div>
                            }
                            {session?.activities && session?.activities.indexOf("app.employee.production_entry") > -1 &&
                                <div className="col-lg-3 col-md-6 col-6 mb-4">
                                    <NavLink to="/production-entry" className="d-block h-100 text-decoration-none">
                                        <div className="card h-100 d-flex flex-column">
                                                <img className="card-img-top" src={ProductionEntryImage} alt="Card image cap"></img>
                                                <div className="card-body d-flex align-items-center justify-content-center text-center" style={{ minHeight: 80 }}>
                                                    <h5 className="card-title mb-0" style={{ display: '-webkit-box', WebkitLineClamp: 2, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>Production Entry</h5>
                                                </div>
                                            </div>
                                    </NavLink>
                                </div>
                            }
                            {(!session || !session.user || !session.user.name) &&
                                <div className='alert alert-danger'>
                                    You are not authorized to access this page. Please contact the administrator.
                                    { JSON.stringify(session?.user) }
                                </div>
                            }
                        </div>
                        <div className='row'>
                            <div className="col-12 mb-4">
                                <div style={{ position: "relative", height: 50 }}>
                                    <div className='version-number'>
                                        <div className="btn btn-sm bg-dark" style={{ marginBottom: 10, color: "#fff", float: "left" }} onClick={clearCache}>Update to latest version</div>
                                        <span style={{ float: "right" }} >{app_version}</span>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </>
                }
            </div>
        </>
    );
};